import { PluginListenerHandle, registerPlugin } from '@capacitor/core';

/**
 * @description: Capacitor Custom Native Plugin,
 * this is an Interface class defining the supported methods
 * you can find more details https://capacitorjs.com/docs/android/custom-code
 *
 */
export interface AppUpdaterPlugin {
  /**
   * @description helps to query the app version if Installed on Device.
   * returns error with msg, if not found
   * @param appPackageID - PackageId / AppId of the App
   * @returns appVersion
   */
  getAppPackageVersion(options: { appPackageID: string }): Promise<{ appVersion: string }>;

  /**
   * @description helps to download and install app on Device.
   * returns status or error, if unable to download. User needs to provide write permission.
   * @param appDownloadUrl - url to download the app.
   * @returns status => downloadStarted
   */
  downloadAppAndInstall(options: { appDownloadUrl: string }): Promise<{ status: string }>;

  /**
   * @description listen to app installation status on the device.
   * return app packge name and status  keys.
   * @returns appPackageName - PackageId / AppId of the App that was installed.
   */
  addListener(
    eventName: 'appPackageInstall',
    listenerFunc: (info: any) => void,
  ): Promise<PluginListenerHandle> & PluginListenerHandle;

  /**
   * @description listen to app download status on the device.
   * return status  keys => Success / Fail.
   * @returns appPackageName - PackageId / AppId of the App that was installed.
   */
  addListener(
    eventName: 'apkDownload',
    listenerFunc: (info: any) => void,
  ): Promise<PluginListenerHandle> & PluginListenerHandle;
}

const AppUpdater = registerPlugin<AppUpdaterPlugin>('AppUpdater');

export default AppUpdater;

/* Example code to addListener and remove Listener

const myAppUpdaterPlugEventListener = await AppUpdaterPlugin.addListener(
  '<myPluginEvent>',
  (info: any) => {
    console.log('<myPluginEvent> was fired');
  },
);

myAppUpdaterPlugEventListener.remove();
*/
